import { render, staticRenderFns } from "./jindu.vue?vue&type=template&id=78c89ac8&scoped=true"
import script from "./jindu.vue?vue&type=script&lang=js"
export * from "./jindu.vue?vue&type=script&lang=js"
import style0 from "./jindu.vue?vue&type=style&index=0&id=78c89ac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c89ac8",
  null
  
)

export default component.exports